// Llamadas a Microsoft Graph para leer el correo institucional del usuario.
// Requiere un access token con scope delegado Mail.Read (obtenido vía MSAL).

const GRAPH = 'https://graph.microsoft.com/v1.0';

const GetFetchGraph = {};

// Bandeja de entrada: últimos mensajes ordenados por fecha de recepción.
GetFetchGraph.getMensajes = async (accessToken, top = 25) => {
    const select = 'subject,from,receivedDateTime,bodyPreview,isRead,webLink';
    // El espacio en "receivedDateTime desc" debe ir codificado (%20) o Graph responde 400.
    const orderby = encodeURIComponent('receivedDateTime desc');
    const url = `${GRAPH}/me/messages?$select=${select}&$top=${top}&$orderby=${orderby}`;
    const res = await fetch(url, {
        headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!res.ok) {
        throw new Error(`Graph respondió ${res.status}`);
    }
    return res.json(); // { value: [ ...mensajes ] }
};

export default GetFetchGraph;
